import { useLang } from "@/i18n";

export default function Commitments() {
  const { t } = useLang();
  const GUARANTEES = [
    { big: "24/7", label: t("com.g1") },
    { big: "100%", label: t("com.g2") },
    { big: "France", label: t("com.g3") },
    { big: "Stripe", label: t("com.g4") },
  ];
  return (
    <section className="py-24 px-6 border-b border-[#212631] bg-[#090b0f]" data-testid="commitments-section">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#c9a24d] block mb-2">{t("com.kicker")}</span>
          <h2 className="font-disp text-3xl md:text-5xl text-white mb-6">{t("com.title")}</h2>

          <div className="grid grid-cols-2 gap-4 pt-2">
            {GUARANTEES.map((g) => (
              <div key={g.label} data-testid={`guarantee-${g.big.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                className="bg-[#0d1017] p-5 rounded-xl border border-[#212631] hover:border-[#c9a24d]/40 transition-colors">
                <div className="font-disp text-3xl font-normal text-[#c9a24d]">{g.big}</div>
                <div className="font-mono text-xs text-[#8c98a9] uppercase mt-1">{g.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="h-80 md:h-96 rounded-2xl border border-[#c9a24d]/30 overflow-hidden relative shadow-2xl" data-testid="fleet-showcase-image">
          <img src="https://images.pexels.com/photos/15535501/pexels-photo-15535501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Berline Mercedes noire en ville" loading="lazy" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#060709] via-transparent to-transparent"></div>
          <div className="absolute bottom-6 left-6 right-6">
            <span className="font-disp text-2xl text-white block">{t("com.imgTitle")}</span>
            <span className="text-xs text-[#8c98a9]">{t("com.imgSub")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}
